import '../assets/css/Central.css'
import '../assets/css/Common.css'
import SmallArticlePreview from './SmallArticlePreview';
import { useContext, useEffect, useState, memo } from 'react';
import ZoomedImage from './ZoomedImage';
import { addThreeDots, formatDate, getImageUrl } from '../services/CommonService';
import { Link } from 'react-router-dom';
import { NUMBER_OF_ARTICLES_IN_CENTRAL } from '../HistoriografijaConstants';
import ArticlesContext from '../context/ArticlesContext';
import { Skeleton } from 'antd';
import purify from 'dompurify'
import 'quill/dist/quill.snow.css'

const loadImage = (setImageDimensions, imageUrl) => {
    const img = new Image();
    img.src = imageUrl;  
    img.onload = () => {
      setImageDimensions({
        height: img.height,
        width: img.width
      });
    };
  };

const Central = memo(function Central() {
    const {state} = useContext(ArticlesContext)
    const centralArticles = state?.centralArticles
    const categories = state?.categories
    const [lastArticle, setLastArticle] = useState(null)
    const [lastArticleImageDimensions, setLastArticleImageDimensions]= useState({})

    useEffect(() => {
        if (centralArticles && centralArticles.length !== 0) {
            setLastArticle(centralArticles[0])
            loadImage(setLastArticleImageDimensions, getImageUrl(centralArticles[0].image.imageName));
        }
    }, [centralArticles, categories, setLastArticle])
    
    return (
        <div className='central-div'>
            {lastArticle ? <Link to={"/" + lastArticle.url} state={{ 
                articleId: lastArticle.id,
                title: lastArticle.title,
                image: lastArticle.image,
                date: formatDate(lastArticle.date),
                url: lastArticle.url,
                categoryName: lastArticle.categoryName,
            }}>
                {lastArticleImageDimensions.width > lastArticleImageDimensions.height ?
                    <div className="left-div float-left flex-column">
                        <ZoomedImage cssClassNames={['main-img']} image={lastArticle.image} imgCssClassNames={'central-left-img'}  />
                        <div className={`main-info`}>
                            <div className="article-title-author">
                                <div className='category-and-title'>
                                    <p className={lastArticle.categoryName === 'Promo' ? 'article-category-left category-name--promo' : 'article-category-left text-black'}>
                                        {lastArticle.categoryName}
                                    </p>
                                    <h1>{lastArticle.title}</h1>
                                    {/* Optional author - if a change is made on the backend to return it in ArticlePreview
                                        lastArticle.author &&<div className='flex-container vertical-centered'>
                                        <FontAwesomeIcon icon={faUser} className='text-gray'></FontAwesomeIcon>
                                        <p className='left-margin-10px text-gray text-italic'>Neko Nekić</p>
                                    </div>*/}
                                </div>
                                <div className='article-description ql-editor no-pre-wrap'
                                    dangerouslySetInnerHTML={{__html: purify.sanitize(addThreeDots(lastArticle.description.replace(/ /g, "\u00A0")))}}
                                    style={{padding: 0}}
                                >
                                </div>
                            </div>
                            <p className='article-date-left'>{formatDate(lastArticle.date)}</p>
                        </div>
                    </div>
                    :
                    <div className="left-div-vertical float-left">
                        <ZoomedImage cssClassNames={['main-img-vertical']} image={lastArticle.image} imgCssClassNames={'central-left-img'}  />
                        <div className={`main-info-vertical`}>
                            <div className="article-title-author">
                                <div className='category-and-title'>
                                    <p className={lastArticle.categoryName === 'Promo' ? 'article-category-left category-name--promo' : 'article-category-left text-black'}>
                                        {lastArticle.categoryName}
                                    </p>
                                    <h1>{lastArticle.title}</h1>
                                    {/* Optional author - if a change is made on the backend to return it in ArticlePreview
                                        lastArticle.author &&<div className='flex-container vertical-centered'>
                                        <FontAwesomeIcon icon={faUser} className='text-gray'></FontAwesomeIcon>
                                        <p className='left-margin-10px text-gray text-italic'>Neko Nekić</p>
                                    </div>*/}
                                </div>
                                <div className='article-description ql-editor no-pre-wrap'
                                    dangerouslySetInnerHTML={{__html: purify.sanitize(addThreeDots(lastArticle.description.replace(/ /g, "\u00A0")))}}
                                    style={{padding: 0}}
                                >
                                </div>
                            </div>
                            <p className='article-date-left'>{formatDate(lastArticle.date)}</p>
                        </div>
                    </div>
                }
            </Link>
            :
            <div className="left-div-loading">
                <Skeleton.Image active style={{ width: '100%', height: '45vh' }} />
                <div style={{ padding: '20px' }}>
                    <Skeleton active paragraph={{ rows: 3 }} />
                </div>
            </div>
            }
            <div className="right-div float-right">
                <p className="title text-center left-margin-20">
                    historiografija.ba <br/>
                    ISSN 2712-2050
                </p>
                <div className="right-subdiv">
                    <div className='top-5 relative-position najnovije-div'>
                        <div className='flex-container'>
                            <div className='vertical-line float-left'></div>
                            <p className='text-white left-margin-3'>Najnovije</p>
                        </div>
                    </div>

                    <div className='flex-container small-article-preview-container'>
                        {
                            centralArticles && centralArticles.length !== 0 ?
                                centralArticles.slice(1, NUMBER_OF_ARTICLES_IN_CENTRAL).map((article) => {
                                return <SmallArticlePreview 
                                        articleId={article.id}
                                        key={article.id}
                                        title={article.title} 
                                        category={article.categoryName} 
                                        date={article.date}
                                        image={article.image}
                                        url={article.url}
                                    />
                                })
                                :
                                <div className='skeleton-on-dark-bg'>
                                    {[...Array(NUMBER_OF_ARTICLES_IN_CENTRAL - 1)].map((e, i) => (
                                        <div className='small-preview-skeleton-row' key={i}>
                                            <Skeleton.Image active />
                                            <div className='skeleton-text-wrapper'>
                                                <Skeleton paragraph={{ rows: 1, width: '100%' }} title={false} active />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        
    )
})

export default Central